import React, {useEffect} from 'react';
import SessionContext from './SessionContext';

import {UserTypes} from "root/DataFunctions/Constants";

import {useIdleTimer} from "react-idle-timer";
import {doesUserHaveRequiredRole} from "root/Contexts/roleFunctions";

const APP_TIMEOUT_MINUTES = 60 ;
export const APP_TIMEOUT = 60 * 1000 * APP_TIMEOUT_MINUTES ;

const DEFAULT_LOGOUT_SCRIPT = "/?action=logout" ;

export const translateArray = ( roleArray ) =>
{
    return JSON.parse(roleArray) ;
}

export const getRoles = ( dataset ) =>
{
    return dataset.roles !== undefined ? translateArray( dataset.roles ) : [];
}

export const getFunctionalRoles = ( dataset ) =>
{
    return dataset.functional_roles !== undefined ? translateArray( dataset.functional_roles ) : [];
}

const SessionProvider = ({children, dataset}) => {

    const onIdle = () =>
    {
        const t = new Date() ;

        console.log ( "Timeout!! at " + t.toString()) ;

        window.location.replace(DEFAULT_LOGOUT_SCRIPT + '&reason=timeout' );
    }

    const onActive = (event) => {
        console.log ( "Active!!") ;
    }
    const { start } = useIdleTimer({
        timeout: APP_TIMEOUT,
        startManually: true,
        onIdle,
        onActive })

    useEffect(() => {
        // Start the inactivity timer
        const results = start() ;

        console.log ( results ) ;
    }, []);

    return (
        <SessionContext.Provider
            value={{
                user_type: +(dataset.user_type),
                child_jwt: dataset.child_jwt,
                firstname: dataset.firstname,
                loggedOnUserIsTeacher: +(dataset.user_type) === UserTypes.DESI_TEACHER,
                roles: getRoles(dataset),
                functional_roles: getFunctionalRoles(dataset),
                hasRole: (role_id) => doesUserHaveRequiredRole(role_id, getFunctionalRoles(dataset)),
            }}
        >
        {children}
        </SessionContext.Provider>
    )
}

export default SessionProvider;